import React, { createContext, useContext, useEffect, useState } from 'react';

const COMPANY_ID = Number(process.env.GATSBY_PIPEDRIVE_COMPANY_ID || 701241);
const PLAYBOOK_UUID = process.env.GATSBY_PIPEDRIVE_PLAYBOOK_UUID;
const LOADER_SCRIPT_ID = 'pipedrive-leadbooster-loader';

const ChatbotContext = createContext(null);

export const ChatbotProvider = ({ children }) => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (!isEnabled || !PLAYBOOK_UUID) return undefined;

    window.pipedriveLeadboosterConfig = {
      base: 'leadbooster-chat.pipedrive.com',
      companyId: COMPANY_ID,
      playbookUuid: PLAYBOOK_UUID,
      version: 2,
    };

    if (!window.LeadBooster) {
      window.LeadBooster = {
        q: [],
        on(n, h) { this.q.push({ t: 'o', n, h }); },
        trigger(n) { this.q.push({ t: 't', n }); },
      };
    }

    if (!document.getElementById(LOADER_SCRIPT_ID)) {
      const s = document.createElement('script');
      s.id = LOADER_SCRIPT_ID;
      s.src = 'https://leadbooster-chat.pipedrive.com/assets/loader.js';
      s.async = true;
      document.body.appendChild(s);
    }

    return () => {
      document.getElementById(LOADER_SCRIPT_ID)?.remove();
      document.getElementById('LeadboosterContainer')?.remove();
    };
  }, [isEnabled]);

  return (
    <ChatbotContext.Provider value={setIsEnabled}>
      {children}
    </ChatbotContext.Provider>
  );
};

// Pages declare their chatbot preference by calling this hook (via Layout).
// Setting the same value repeatedly is a no-op thanks to React's useState bail-out,
// so navigations between two enabled pages do not re-trigger the setup/teardown effect.
export const useChatbot = (enabled) => {
  const setIsEnabled = useContext(ChatbotContext);
  useEffect(() => {
    // Use the setter function returned by the context 
    // to set the isEnabled state value inside the ChatbotProvider
    setIsEnabled(!!enabled);
  }, [enabled, setIsEnabled]);
};
